module.exports = __webpack_public_path__ + "static/media/pending.37e5388f.svg";